import React, { useContext, useState } from 'react';
// material
import {
  Card,
  Container,
  Box,
  Stepper,
  Step,
  StepLabel,
  StepContent,
  Typography,
  Stack
} from '@mui/material';
// contexts
import { EventContext } from '../../contexts/Event';
// components
import Page from '../../components/Page';
import EventFormBasic from '../../components/event/form/basic';
import EventFormCalendar from '../../components/event/form/calendar';
import EventFormLocation from '../../components/event/form/location';
import EventFormInfo from '../../components/event/form/info';
import EventFormSeatsIO from '../../components/event/form/seatsio';
import EventFormTheme from '../../components/event/form/theme';

// ----------------------------------------------------------------------

// TODO: mudar para swipe
export default function EventCreate() {
  const { event } = useContext(EventContext);

  const [activeStep, setActiveStep] = useState(0);

  const handleNext = () => {
    setActiveStep((nextActiveStep) => nextActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  return (
    <Page title="Event" path="/event/edit">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4">Details / Edit</Typography>
        </Stack>

        <Card sx={{ mt: 3 }}>
          <Box sx={{ p: { xs: 1, sm: 3 } }}>
            <Stepper activeStep={activeStep} orientation="vertical">
              <Step>
                <StepLabel onClick={() => setActiveStep(0)} sx={{ cursor: 'pointer !important' }}>
                  Basic Info
                </StepLabel>
                <StepContent TransitionProps={{ unmountOnExit: false }}>
                  <Box sx={{ pt: 2 }}>
                    <EventFormBasic event={event} handleNext={handleNext} edit />
                  </Box>
                </StepContent>
              </Step>

              <Step>
                <StepLabel onClick={() => setActiveStep(1)} sx={{ cursor: 'pointer !important' }}>
                  Schedule
                </StepLabel>
                <StepContent TransitionProps={{ unmountOnExit: false }}>
                  <Box sx={{ pt: 2 }}>
                    <EventFormCalendar
                      event={event}
                      handleBack={handleBack}
                      handleNext={handleNext}
                      edit
                    />
                  </Box>
                </StepContent>
              </Step>

              <Step>
                <StepLabel onClick={() => setActiveStep(2)} sx={{ cursor: 'pointer !important' }}>
                  Event Location
                </StepLabel>
                <StepContent TransitionProps={{ unmountOnExit: false }}>
                  <Box sx={{ pt: 2 }}>
                    <EventFormLocation
                      event={event}
                      handleBack={handleBack}
                      handleNext={handleNext}
                      edit
                    />
                  </Box>
                </StepContent>
              </Step>

              <Step>
                <StepLabel onClick={() => setActiveStep(3)} sx={{ cursor: 'pointer !important' }}>
                  Add Additional Info
                  <Typography component="span" variant="body2" color="grey.500" ml={1}>
                    (Optional)
                  </Typography>
                </StepLabel>
                <StepContent TransitionProps={{ unmountOnExit: false }}>
                  <Box sx={{ pt: 2 }}>
                    <EventFormInfo
                      event={event}
                      handleNext={handleNext}
                      handleBack={handleBack}
                      edit
                    />
                  </Box>
                </StepContent>
              </Step>

              {event?.bookingType === 'SEATSIO' && (
                <Step>
                  <StepLabel onClick={() => setActiveStep(4)} sx={{ cursor: 'pointer !important' }}>
                    Seats Settings
                  </StepLabel>
                  <StepContent TransitionProps={{ unmountOnExit: false }}>
                    <Box sx={{ pt: 2 }}>
                      <EventFormSeatsIO
                        event={event}
                        handleBack={handleBack}
                        handleNext={handleNext}
                        edit
                      />
                    </Box>
                  </StepContent>
                </Step>
              )}

              <Step>
                <StepLabel
                  optional={<Typography variant="caption">Color, Logo, Banner</Typography>}
                  onClick={() => setActiveStep(event?.bookingType === 'SEATSIO' ? 5 : 4)}
                  sx={{ cursor: 'pointer !important' }}
                >
                  Choose Your Theme
                </StepLabel>
                <StepContent TransitionProps={{ unmountOnExit: false }}>
                  <Box sx={{ pt: 2 }}>
                    <EventFormTheme event={event} handleBack={handleBack} edit />
                  </Box>
                </StepContent>
              </Step>
            </Stepper>
          </Box>
        </Card>
      </Container>
    </Page>
  );
}
